import { useFlags } from "launchdarkly-react-client-sdk";
import { LDFlagKey } from "./flags";

const useIsFlagEnabled = () => {
  const flags = useFlags();

  const isFlagEnabled = (flag?: LDFlagKey) => {
    if (!flag) return true;
    return Boolean(flags[flag]);
  };

  return isFlagEnabled;
};

export default useIsFlagEnabled;
